import { createFileRoute } from '@tanstack/react-router';

import { addTrackCrumb } from '../../../../../../error/tracking';

type SubscriptionSearch = {
  status: string;
};

export const Route = createFileRoute(
  '/app/settings/_sidebar-settings-layout/organization/$id/_tabs-layout/billing-legacy'
)({
  beforeLoad: function () {
    addTrackCrumb({
      category: 'route',
      message: '/app/settings/_sidebar-settings-layout/organization/$id/_tabs-layout/billing',
      level: 'info',
    });
  },
  validateSearch: function (search: Record<string, unknown>): SubscriptionSearch {
    return {
      status: (search.status as string) ?? '',
    };
  },

  // eslint-disable-next-line no-use-before-define
  component: BillingTab,
});

export function BillingTab() {
  // TODO: need to handle the billing tab
  return <>Not implemented yet. Needs to be reviewed</>;
}
